module.exports = __webpack_public_path__ + "static/media/img_socialmedia-06wechat.eff3886b.png";